import PageWrapper from "../../shared/wizard/PageWrapper";
import Styles from "../AnonForms.module.css";
import { yesNoUnsure } from "../../../constants/options";
import { textToBoolean } from "../../../utilities/dataUtilities";

function PoliceContacted({
  fields,
  utilities,
}) {
  const {
    createToggleInput,
    createWizInput,
  } = utilities;

  const wizProps = {
    labelWidth: "6rem",
    isRow: true,
    punctuate: ":"
  };

  return (
    <PageWrapper legendInfo="Report: ">
      {createToggleInput(fields.policeAgencyContacted, "80%", yesNoUnsure, true)}
      {textToBoolean(fields.policeAgencyContacted.value) && (
         <div
         style={{ margin: "1.1rem 0px 0.5rem 1rem" }}
         className={Styles.fadeIn}
       >
        {createWizInput(fields.reportAgencyName, "80%", Styles.anonInput, wizProps)}
        {createWizInput(fields.reportNumber, "80%", Styles.anonInput, wizProps)}
        </div>
      )}
    </PageWrapper>
  );
}

export default PoliceContacted;
